import { getAdminBillingSignupDrafts, type AdminSignupDraftItemSchema, type AdminSignupDraftPlanSchema } from '@/generated/api-client'
import { configureOpenApiClient } from '@/lib/api/client/configure-openapi-client'

configureOpenApiClient()

export type AdminSignupDraftStatus = 'pending_verification' | 'verified' | 'org_drafted' | 'plan_selected' | 'checkout_pending' | 'abandoned'

export type AdminSignupDraftPlan = AdminSignupDraftPlanSchema

export type AdminSignupDraftListItem = Omit<AdminSignupDraftItemSchema, 'status' | 'createdAt' | 'updatedAt'> & {
    status: AdminSignupDraftStatus
    createdAt: string
    updatedAt: string
}

function toIsoString(value: string | Date): string {
    if (typeof value === 'string') return value
    return value.toISOString()
}

export async function fetchAdminSignupDrafts(): Promise<AdminSignupDraftListItem[]> {
    const { data } = await getAdminBillingSignupDrafts({ throwOnError: true })
    const rows = data?.data ?? []
    return rows.map((row) => ({
        ...row,
        status: (row.status as AdminSignupDraftStatus) ?? 'pending_verification',
        createdAt: toIsoString(row.createdAt),
        updatedAt: toIsoString(row.updatedAt),
    }))
}
